import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';

const rootDom = document.getElementById('form');
if (rootDom) {
  const root = createRoot(rootDom);
  root.render(<App />);
}

const formModalDom = document.getElementById('form-modal');
if (formModalDom) {
  const modalRoot = createRoot(formModalDom);
  modalRoot.render(<App modal={true} />);
}

const heroFormDom = document.getElementById('form-hero');
if (heroFormDom) {
  const heroRoot = createRoot(heroFormDom);
  heroRoot.render(<App hero={true} />);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
